import { getLocale, subscribeLocale, t } from "./runtime";

export function applyDocumentLocale(): void {
  document.documentElement.lang = getLocale();
  document.title = t("meta.title");
  document
    .querySelector('meta[name="description"]')
    ?.setAttribute("content", t("meta.description"));
}

export function startDocumentLocale(): () => void {
  applyDocumentLocale();
  return subscribeLocale(applyDocumentLocale);
}
